export default __webpack_public_path__ + "static/assets/a58d87cb7ce587fa7dcf05f3c3e97386.svg";